module.exports = __webpack_public_path__ + "static/media/local.98905579.png";